/* global axios */
import ApiClient from './ApiClient';

class OrdersAPI extends ApiClient {
  constructor() {
    super('orders', { accountScoped: true });
  }

  updateStatus(id, status) {
    return axios.post(`${this.url}/${id}/update_status`, { status });
  }
}

export default new OrdersAPI();
